import React, {useState} from 'react';
import * as yup from 'yup';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { classNames } from 'primereact/utils';
import { useFormik } from 'formik';
import {useChangePasswordMutation} from 'apis/authenticationApi';
import {useNavigate} from "react-router-dom";

const ResetPasswordForm = ({token}) => {
    const schema = yup.object({
        password: yup.string().required('Please enter a password')
            .matches(
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/,
                "Password must contain at least 8 characters, one uppercase, one lowercase, one number and one special character"
            ),
        passwordConfirmation: yup.string().required('Please enter password again')
            .oneOf([yup.ref('password'), null], 'Confirm password does not match')
    });
    const navigate = useNavigate();
    const [changePassword] = useChangePasswordMutation();
    const [messages, setMessages] = useState("");

    const formik = useFormik({
        initialValues: { password: '', passwordConfirmation: '', token },
        validationSchema: schema,
        onSubmit: async (data) => {
            setMessages("");

            const results = await changePassword(data);

            if(results?.data?.status === 'ok') {
                navigate('/auth/reset-password-thankyou');
            }
            else {
                setMessages("Reset Password Invalid");
            }
        }
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <form onSubmit={formik.handleSubmit} className="formgrid grid">
            <div className="col-12">
                <span className="error">{messages}</span>
            </div>
            <div className="field col-12">
                <span className="p-float-label">
                    <Password autoComplete="new-password" id="password" name="password" className="inputfield w-full" toggleMask value={formik.values?.password} onChange={formik.handleChange} />
                    <label htmlFor="password" className={classNames({ 'p-error': isFormFieldValid('password') })}>Password</label>
                </span>
                {getFormErrorMessage('password')}
            </div>
            <div className="field col-12">
                <span className="p-float-label">
                    <Password autoComplete="new-password" feedback={false} id="passwordConfirmation" name="passwordConfirmation" className="inputfield w-full" toggleMask value={formik.values?.passwordConfirmation} onChange={formik.handleChange} />
                    <label htmlFor="passwordConfirmation" className={classNames({ 'p-error': isFormFieldValid('passwordConfirmation') })}>Confirm Password</label>
                </span>
                {getFormErrorMessage('passwordConfirmation')}
            </div>
            <div className="field col-12">
                <Button type="submit" label="Reset Password" />
            </div>
        </form>
    );
}

export default ResetPasswordForm;